import React, { useEffect, useRef, useState } from 'react';
import { camelCase } from 'lodash';
import styled from 'styled-components';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, LinearProgress, Typography } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { AppSnackbar } from '@sierralabs/core-ui';
import { useDeleteEntityData } from '../hooks/useDeleteEntityData';
const StyledDialogContent = styled(DialogContent) `
  .content {
    margin-bottom: 8px;
  }
  .entity-list {
    padding-left: 28px;
  }
  .MuiAlertTitle-root {
    font-size: 15px;
    font-weight: 600;
  }
`;
const DeleteEntityDataDialog = props => {
    const { open, data, entity, onCancel, onDelete } = props;
    const onDeleteRef = useRef(onDelete);
    const [cascade, setCascade] = useState(false);
    const [error, setError] = useState();
    const [snackbarError, setSnackbarError] = useState();
    const primaryCol = entity.columns.find(column => column.primary);
    const dataId = primaryCol && (data === null || data === void 0 ? void 0 : data[primaryCol.name || camelCase(primaryCol.displayName)]);
    const { isDeleting, deleteError, response, deleteEntityData } = useDeleteEntityData(entity.tableName, dataId);
    const isDeleteError = error &&
        error.statusCode === 409 &&
        error.error === 'Delete Conflict' &&
        Array.isArray(error.entities);
    const relatedLength = error && Array.isArray(error.entities) ? error.entities.length : 0;
    // disable closing if deleting
    const onClose = () => !isDeleting && (onCancel === null || onCancel === void 0 ? void 0 : onCancel());
    const renderData = (v) => (React.createElement(React.Fragment, null,
        React.createElement("strong", null, v.name),
        " (ID: ",
        React.createElement("strong", null, v.id),
        ")"));
    useEffect(() => {
        onDeleteRef.current = onDelete;
    }, [onDelete]);
    // reset values
    useEffect(() => {
        if (open) {
            setCascade(false);
            setError(undefined);
        }
    }, [open]);
    useEffect(() => {
        var _a;
        if (response === null || response === void 0 ? void 0 : response.ok) {
            (_a = onDeleteRef.current) === null || _a === void 0 ? void 0 : _a.call(onDeleteRef);
        }
    }, [response]);
    useEffect(() => {
        if (deleteError) {
            setError(deleteError);
            setSnackbarError(deleteError);
        }
    }, [deleteError]);
    return (React.createElement(Dialog, { open: open, onClose: onClose },
        isDeleting && React.createElement(LinearProgress, null),
        React.createElement(DialogTitle, null,
            "Delete ",
            entity.name,
            " Entity (ID: ",
            dataId,
            ")"),
        React.createElement(StyledDialogContent, null,
            error && isDeleteError && (React.createElement(Alert, { severity: 'error', className: 'content' },
                React.createElement(AlertTitle, null, error.error),
                React.createElement(Typography, { variant: 'body2' },
                    error.message,
                    " You can choose to delete with the",
                    ' ',
                    React.createElement("strong", null, "CASCADE"),
                    " option by checking the box below."))),
            error && isDeleteError && (React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: 'body2', className: 'content' },
                    "Listed below are the entities that reference this entity. Note that if ",
                    React.createElement("strong", null, "CASCADE"),
                    " is checked, these entities will also be included in the ",
                    React.createElement("strong", null, "DELETE"),
                    "."),
                React.createElement("ul", { className: 'entity-list' }, (error.entities || []).map((entity, index) => (React.createElement("li", { key: `${entity.name}-${index}` },
                    React.createElement(Typography, { variant: 'body2' }, renderData(entity)))))),
                React.createElement(FormControlLabel, { className: 'content', label: React.createElement(Typography, { variant: 'body2' },
                        "Enable ",
                        React.createElement("strong", null, "DELETE CASCADE")), control: React.createElement(Checkbox, { color: 'primary', checked: cascade, disabled: isDeleting, onChange: () => setCascade(!cascade) }) }))),
            React.createElement(Typography, { variant: 'body2', className: 'content' },
                "Are you sure you want to ",
                React.createElement("strong", null, "DELETE"),
                " entity",
                ' ',
                renderData({ id: dataId, name: entity.name }),
                " and",
                ' ',
                !(cascade && error && isDeleteError) ? ('all of its content?') : (React.createElement(React.Fragment, null,
                    React.createElement("strong", null,
                        relatedLength,
                        " other",
                        ' ',
                        relatedLength === 1 ? 'entity' : 'entities'),
                    ' ',
                    "listed above?")),
                ' ',
                "This action is cannot be undone.")),
        React.createElement(DialogActions, null,
            React.createElement(Button, { disabled: isDeleting, onClick: onClose }, "Cancel"),
            React.createElement(Button, { color: 'primary', variant: 'contained', disabled: isDeleting, onClick: () => deleteEntityData(cascade) },
                "Confirm DELETE",
                cascade && ' CASCADE')),
        React.createElement(AppSnackbar, { severity: 'error', open: !!snackbarError, onClose: () => setSnackbarError(undefined) }, snackbarError === null || snackbarError === void 0 ? void 0 : snackbarError.message)));
};
export default DeleteEntityDataDialog;
//# sourceMappingURL=DeleteEntityDataDialog.js.map